import { h } from "omi";

export function CountryUSAIcon() {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#a)">
        <path
          d="M10 20c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C4.4771 0 0 4.4771 0 10c0 5.5228 4.4771 10 10 10Z"
          fill="#F0F0F0"
        />
        <path
          d="M9.565 10.0001h10.4347a10.01 10.01 0 0 0-.3445-2.6087H9.5649V10ZM9.565 4.782h8.967a10.0549 10.0549 0 0 0-2.3074-2.6087H9.5649v2.6088ZM9.9998 20.0001c2.3534 0 4.5166-.8135 6.2248-2.1739H3.7749c1.7082 1.3604 3.8714 2.1739 6.2248 2.1739ZM1.4675 15.2166H18.532a9.9401 9.9401 0 0 0 1.1233-2.6087H.3443a9.9406 9.9406 0 0 0 1.1232 2.6087Z"
          fill="#D80027"
        />
        <path
          d="M4.6322 1.5616h.9113l-.8477.6159.3238.9964-.8476-.6158-.8476.6158.2797-.8608a10.0549 10.0549 0 0 0-1.9396 2.1616h.292l-.5395.392a9.9825 9.9825 0 0 0-.242.4272l.2577.793-.4807-.3492a9.9054 9.9054 0 0 0-.327.7763l.2838.8737h1.0477l-.8476.6159L1.4327 9 .585 8.3842l-.5077.3689A10.0962 10.0962 0 0 0 0 10h10V0C8.0245 0 6.183.573 4.6322 1.5616ZM5.0196 9l-.8476-.6158L3.3244 9l.3238-.9964-.8477-.6159h1.0477l.3238-.9964.3237.9964h1.0478l-.8477.6159L5.0196 9Zm-.3238-3.9095.3238.9965-.8476-.6159-.8476.6159.3238-.9965-.8477-.6158h1.0477l.3238-.9965.3237.9965h1.0478l-.8477.6158ZM8.6066 9l-.8477-.6158L6.9113 9l.3238-.9964-.8476-.6159h1.0477l.3237-.9964.3238.9964h1.0477l-.8476.6159L8.6066 9Zm-.3238-3.9095.3238.9965-.8477-.6159-.8476.6159.3238-.9965-.8476-.6158h1.0477l.3237-.9965.3238.9965h1.0477l-.8476.6158Zm0-2.913.3238.9964-.8477-.6158-.8476.6158.3238-.9964-.8476-.6159h1.0477l.3237-.9964.3238.9964h1.0477l-.8476.6159Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
